/**
 * configuration applied when BROCOLI_API_MODE = staging
 */
module.exports = {}
